// src/admin-components/AdminContacts.jsx
import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar  from "./Topbar";
import "./admin-dashboard.css";

// ✅ Fix
// const BASE_URL = "https://suvidha-backend-353j.onrender.com";
const BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/api$/, "") || "https://api.suvidhaeldercare.com";

function authHeaders() {
  const t = localStorage.getItem("token");
  return { "Content-Type":"application/json", ...(t?{Authorization:`Bearer ${t}`}:{}) };
}

const STATUS_CFG = {
  new:     { label:"New",     bg:"#DBEAFE", color:"#1E40AF" },
  read:    { label:"Read",    bg:"#F1F5F9", color:"#64748B" },
  replied: { label:"Replied", bg:"#D1FAE5", color:"#065F46" },
  closed:  { label:"Closed",  bg:"#F3F4F6", color:"#6B7280" },
};

const fmtTime = (d) => {
  const diff = Math.floor((Date.now() - new Date(d)) / 1000);
  if (diff < 60)    return "just now";
  if (diff < 3600)  return `${Math.floor(diff/60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff/3600)}h ago`;
  return new Date(d).toLocaleDateString("en-IN", { day:"numeric", month:"short", year:"numeric" });
};

// ── Detail Drawer ─────────────────────────────────────────
function EnquiryDrawer({ item, onClose, onUpdated }) {
  const [status, setStatus] = useState(item.status);

  const updateStatus = async (s) => {
    setStatus(s);
    await fetch(`${BASE_URL}/api/contact/admin/${item.id}/status`, {
      method:"PATCH", headers:authHeaders(), body:JSON.stringify({ status:s })
    });
    onUpdated();
  };

  const cfg = STATUS_CFG[status] || STATUS_CFG.new;

  return (
    <>
      <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.45)", zIndex:2000, backdropFilter:"blur(3px)" }}/>
      <div style={{
        position:"fixed", top:0, right:0, height:"100vh",
        width:"min(500px, 100vw)",
        background:"#fff", zIndex:2001, boxShadow:"-8px 0 40px rgba(0,0,0,.15)",
        display:"flex", flexDirection:"column", overflowY:"auto"
      }}>
        {/* Header */}
        <div style={{ padding:"20px 24px", background: item.type==="call_request"?"#F0FDF4":"#EFF6FF",
          borderBottom:"1px solid #E2E8F0", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <div>
            <div style={{ fontSize:18, fontWeight:800, color:"#1E293B" }}>
              {item.type === "call_request" ? "📞 Call Request" : "✉️ Message"}
            </div>
            <div style={{ fontSize:13, color:"#64748B", marginTop:2 }}>#{item.id} · {fmtTime(item.created_at)}</div>
          </div>
          <button onClick={onClose} style={{ background:"#F1F5F9", border:"none", width:34, height:34,
            borderRadius:"50%", cursor:"pointer", fontSize:16, color:"#64748B" }}>✕</button>
        </div>

        <div style={{ padding:24, display:"flex", flexDirection:"column", gap:18 }}>

          {/* Sender info */}
          <div style={{ background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:14, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:800, color:"#94A3B8", textTransform:"uppercase", letterSpacing:".4px", marginBottom:10 }}>
              Sender Details
            </div>
            {[
              { label:"Name",    value: item.name },
              { label:"Phone",   value: <a href={`tel:${item.phone}`} style={{ color:"#1F4E8C", fontWeight:700, textDecoration:"none" }}>{item.phone} 📞</a> },
              { label:"Email",   value: item.email || "—" },
              { label:"Subject", value: item.subject || "—" },
            ].map(({ label, value }) => (
              <div key={label} style={{ display:"flex", justifyContent:"space-between", padding:"7px 0",
                borderBottom:"1px solid #E2E8F0", fontSize:14 }}>
                <span style={{ color:"#64748B" }}>{label}</span>
                <span style={{ fontWeight:600, color:"#1E293B" }}>{value}</span>
              </div>
            ))}
          </div>

          {/* Message */}
          <div style={{ background:"#F8FAFC", border:"1px solid #E2E8F0", borderRadius:14, padding:16 }}>
            <div style={{ fontSize:12, fontWeight:800, color:"#94A3B8", textTransform:"uppercase", letterSpacing:".4px", marginBottom:8 }}>
              Message
            </div>
            <p style={{ margin:0, fontSize:14, color:"#1E293B", lineHeight:1.7 }}>{item.message}</p>
          </div>



          {/* Status */}
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:"#374151", marginBottom:8 }}>Update Status</div>
            <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
              {Object.entries(STATUS_CFG).map(([s, c]) => (
                <button key={s} onClick={() => updateStatus(s)} style={{
                  padding:"6px 14px", borderRadius:20, border:"2px solid",
                  borderColor: status===s ? c.color : "#E2E8F0",
                  background:  status===s ? c.bg : "#fff",
                  color:       status===s ? c.color : "#64748B",
                  fontWeight:700, fontSize:12, cursor:"pointer", fontFamily:"inherit"
                }}>{c.label}</button>
              ))}
            </div>
          </div>

          {/* Quick actions */}
          <div style={{ display:"flex", gap:10 }}>
            <a href={`tel:${item.phone}`} style={{
              flex:1, padding:"11px", borderRadius:12,
              background:"#F0FDF4", border:"1px solid #A7F3D0",
              color:"#16A34A", fontWeight:700, fontSize:14,
              textDecoration:"none", textAlign:"center"
            }}>📞 Call Now</a>
            <a href={`https://wa.me/91${item.phone}?text=${encodeURIComponent(`Hi ${item.name}, this is Suvidha Elder Care team. We received your enquiry and wanted to follow up.`)}`}
              target="_blank" rel="noreferrer" style={{
              flex:1, padding:"11px", borderRadius:12,
              background:"#F0FDF4", border:"1px solid #86EFAC",
              color:"#16A34A", fontWeight:700, fontSize:14,
              textDecoration:"none", textAlign:"center"
            }}>💬 WhatsApp</a>
          </div>



        </div>
      </div>
    </>
  );
}

// ── Main Page ─────────────────────────────────────────────
export default function AdminContacts() {
  const [enquiries, setEnquiries] = useState([]);
  const [counts,    setCounts]    = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [filters,   setFilters]   = useState({ status:"", type:"", search:"" });
  const [selected,  setSelected]  = useState(null);

  const load = async (f = filters) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (f.status) params.append("status", f.status);
      if (f.type)   params.append("type",   f.type);
      if (f.search) params.append("search", f.search);
      const res  = await fetch(`${BASE_URL}/api/contact/admin?${params}`, { headers: authHeaders() });
      const data = await res.json();
      setEnquiries(data.enquiries || []);
      setCounts(data.counts);
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const setFilter = (k, v) => {
    const next = { ...filters, [k]: v };
    setFilters(next);
    load(next);
  };

  const markRead = async (item) => {
    if (item.status === "new") {
      await fetch(`${BASE_URL}/api/contact/admin/${item.id}/status`, {
        method:"PATCH", headers:authHeaders(), body:JSON.stringify({ status:"read" })
      });
      load();
    }
    setSelected(item);
  };

  return (
    <div className="adm-layout">
      <Sidebar />
      <main className="adm-main">
        <div className="adm-shell">
          <Topbar title="Contact Enquiries" subtitle="Messages & call requests from users" />

          {/* Summary cards */}
          {counts && (
            <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10, marginBottom:18 }}
              className="ac-kpi-grid">
              {[
                { icon:"📬", label:"Total",         val:counts.total,        bg:"#EFF6FF", color:"#1D4ED8" },
                { icon:"🆕", label:"New",            val:counts.new_count,    bg:"#FEF3C7", color:"#D97706" },
                { icon:"📞", label:"Call Requests",  val:counts.call_requests,bg:"#D1FAE5", color:"#059669" },
                { icon:"✅", label:"Replied",         val:counts.replied_count,bg:"#F0FDF4", color:"#16A34A" },
              ].map(k => (
                <div key={k.label} style={{ background:k.bg, border:`1px solid ${k.color}22`,
                  borderRadius:14, padding:"16px 18px" }}>
                  <div style={{ fontSize:22, marginBottom:4 }}>{k.icon}</div>
                  <div style={{ fontSize:26, fontWeight:900, color:k.color }}>{k.val}</div>
                  <div style={{ fontSize:12, color:"#64748B", fontWeight:600 }}>{k.label}</div>
                </div>
              ))}
            </div>
          )}

          {/* Filters */}
          <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:18 }}>
            <input value={filters.search} onChange={e=>setFilter("search",e.target.value)}
              placeholder="🔍 Search name, phone, message..."
              style={{ padding:"9px 14px", borderRadius:10, border:"1px solid #CBD5E1",
                fontSize:14, outline:"none", width:"100%", boxSizing:"border-box" }}
            />
            {/* Type + Status filters — horizontally scrollable */}
            <div style={{ display:"flex", gap:6, overflowX:"auto", scrollbarWidth:"none", paddingBottom:4 }}>
              {[["","All"],["message","✉️ Messages"],["call_request","📞 Calls"]].map(([v,l]) => (
                <button key={v} onClick={()=>setFilter("type",v)} style={{
                  padding:"7px 12px", borderRadius:20, border:"none", cursor:"pointer",
                  fontWeight:700, fontSize:12, whiteSpace:"nowrap", flexShrink:0,
                  background: filters.type===v ? "#1F4E8C" : "#F1F5F9",
                  color:      filters.type===v ? "#fff"    : "#64748B",
                  fontFamily:"inherit"
                }}>{l}</button>
              ))}
              <div style={{ width:1, background:"#E2E8F0", flexShrink:0, margin:"0 2px" }}/>
              {[["","All Status"],["new","🆕 New"],["replied","✅ Replied"],["closed","🔒 Closed"]].map(([v,l]) => (
                <button key={v} onClick={()=>setFilter("status",v)} style={{
                  padding:"7px 12px", borderRadius:20, border:"none", cursor:"pointer",
                  fontWeight:700, fontSize:12, whiteSpace:"nowrap", flexShrink:0,
                  background: filters.status===v ? "#1F4E8C" : "#F1F5F9",
                  color:      filters.status===v ? "#fff"    : "#64748B",
                  fontFamily:"inherit"
                }}>{l}</button>
              ))}
            </div>
          </div>

          {/* Enquiry list */}
          <div className="adm-panel" style={{ gridColumn:"span 12", padding:0, overflow:"hidden" }}>
            {loading ? (
              <div style={{ padding:40, textAlign:"center", color:"#94A3B8" }}>Loading enquiries...</div>
            ) : enquiries.length === 0 ? (
              <div style={{ padding:60, textAlign:"center" }}>
                <div style={{ fontSize:48, marginBottom:12 }}>📭</div>
                <div style={{ fontWeight:700, color:"#1E293B", marginBottom:6 }}>No enquiries found</div>
                <div style={{ color:"#94A3B8", fontSize:14 }}>Contact form submissions will appear here.</div>
              </div>
            ) : (
              <div>
                {enquiries.map(item => {
                  const cfg = STATUS_CFG[item.status] || STATUS_CFG.new;
                  const isCall = item.type === "call_request";
                  return (
                    <div key={item.id} onClick={() => markRead(item)} style={{
                      display:"flex", alignItems:"flex-start", gap:14,
                      padding:"16px 20px", borderBottom:"1px solid #F1F5F9",
                      cursor:"pointer", transition:"background .15s",
                      background: item.status==="new" ? "#FEFCE8" : "#fff"
                    }}
                      onMouseEnter={e=>e.currentTarget.style.background="#F8FAFC"}
                      onMouseLeave={e=>e.currentTarget.style.background=item.status==="new"?"#FEFCE8":"#fff"}
                    >
                      {/* Type icon */}
                      <div style={{ width:42, height:42, borderRadius:12, flexShrink:0,
                        background: isCall?"#D1FAE5":"#EFF6FF",
                        display:"flex", alignItems:"center", justifyContent:"center", fontSize:20 }}>
                        {isCall ? "📞" : "✉️"}
                      </div>

                      {/* Content */}
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
                          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                            <span style={{ fontWeight:800, fontSize:14, color:"#1E293B" }}>{item.name}</span>
                            {item.status === "new" && (
                              <span style={{ width:7, height:7, borderRadius:"50%", background:"#F59E0B", display:"inline-block" }}/>
                            )}
                          </div>
                          <span style={{ fontSize:11, color:"#94A3B8" }}>{fmtTime(item.created_at)}</span>
                        </div>
                        <div style={{ fontSize:13, color:"#64748B", marginBottom:4 }}>
                          📱 {item.phone}
                          {item.subject && <span style={{ marginLeft:8, color:"#94A3B8" }}>— {item.subject}</span>}
                        </div>
                        <div style={{ fontSize:13, color:"#475569", lineHeight:1.4,
                          whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:"90%" }}>
                          {item.message}
                        </div>
                        {item.admin_reply && (
                          <div style={{ fontSize:12, color:"#059669", marginTop:4, fontWeight:600 }}>
                            ✅ Replied
                          </div>
                        )}
                      </div>

                      {/* Status badge */}
                      <span style={{ fontSize:11, fontWeight:800, padding:"4px 10px",
                        borderRadius:999, background:cfg.bg, color:cfg.color, flexShrink:0 }}>
                        {cfg.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </main>

      {/* Detail Drawer */}
      {selected && (
        <EnquiryDrawer
          item={selected}
          onClose={() => setSelected(null)}
          onUpdated={() => { load(); setSelected(null); }}
        />
      )}
    </div>
  );
}